export const sortCollection = (collection, sortBy) => {
  return collection?.sort((a, b) => {
    const key = sortBy?.key;
    const isDate =
      key === "createdAt" ||
      key === "updatedAt" ||
      key === "lastUpdatedAt" ||
      key === "created_at" ||
      key === "updated_at";

    const rawA = a[key];
    const rawB = b[key];
    const valueA = isDate
      ? rawA
      : typeof rawA === "string"
      ? rawA.toLowerCase()
      : rawA;
    const valueB = isDate
      ? rawB
      : typeof rawB === "string"
      ? rawB.toLowerCase()
      : rawB;

    return valueA > valueB ? sortBy?.value : sortBy?.value * -1;
  });
};
